/**
 * Services FAQ category tabs — shows one accordion panel at a time.
 * @param {HTMLElement} section
 */
export function initServicesFaqTabs(section) {
	const tablist = section.querySelector('.services-faq__tabs');
	const panels = section.querySelectorAll('.services-faq__panel');

	if (!tablist || !panels.length) {
		return;
	}

	const tabs = tablist.querySelectorAll('.services-faq__tab');

	const activatePanel = (index) => {
		const indexStr = String(index);

		tabs.forEach((tab) => {
			const isActive = tab.dataset.faqTabIndex === indexStr;
			tab.classList.toggle('is-active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		panels.forEach((panel) => {
			const isActive = panel.dataset.faqPanel === indexStr;
			panel.classList.toggle('is-active', isActive);
			panel.hidden = !isActive;
		});
	};

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			activatePanel(tab.dataset.faqTabIndex);
		});
	});
}

export function initServicesFaqSections() {
	document.querySelectorAll('.js-services-faq-section').forEach((section) => {
		initServicesFaqTabs(section);
	});
}
